import { Navbar } from "../../components/admin-panel/navbar";
import React, { useEffect, useState } from "react";
import { FaFilePdf, FaFileExcel } from "react-icons/fa6";
import { BiSolidFileJpg, BiSolidFilePng } from "react-icons/bi";
import { IoDocumentText } from "react-icons/io5";
import { X } from "lucide-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import ChatService from "../../services/chat/chat";
import { toastError, toastSuccess } from "../../components/ToastNotification";
import AddFile from "../../components/AddFiles";
import { useDispatch, useSelector } from "react-redux";
import UserService from "../../services/user/user";
import { setUser } from "../../store/slices/userSlice";
import { FaVideo } from "react-icons/fa";
import Loader from "../../assets/images/loader/loader.gif";
import Upload from "../../assets/images/upload.svg";
import { Footer } from "../../components/admin-panel/footer";
import { Progress } from "../../components/ui/progress";
import NoFiles from "../../assets/images/NoFiles.svg";

const Organization = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [company, setCompany] = useState("");
  const [companyId, setCompanyId] = useState("");
  const [fileType, setFileType] = useState(""); // To track file type
  const [file, setFile] = useState(""); // To track file type
  const [selectedFile, setSelectedFile] = useState(null); // To keep file display after submission
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false); // State for modal visibility
  const [fileDeleteLoading, setFileDeleteLoading] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [progress, setprogress] = React.useState(0);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isCompressing, setIsCompressing] = useState(false);
  const [fileSizeError, setFileSizeError] = useState("");

  const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes
  const SMALL_CHUNK_SIZE = 5 * 1024 * 1024; // 1MB in bytes for files <= 5MB
  const LARGE_CHUNK_SIZE = MAX_FILE_SIZE; // 5MB in bytes for larger files
  const VIDEO_TYPE = "video";

  // const handleSubmit = async (values) => {
  //   setLoading(true);
  //   const fileArray = Array.isArray(values.file) ? values.file : [values.file];
  //   const isVideo = fileArray?.some((file) => file?.type.includes("video"));

  //   setUploadedFiles(fileArray);
  //   try {
  //     const formData = new FormData();
  //     if (fileArray && fileArray.length > 0) {
  //       // Loop through each file and upload them one by one
  //       fileArray.forEach((file) => formData.append("file", file));
  //     } else {
  //       formData.append("file", values.file);
  //     }
  //     formData.append("category", values.category);
  //     const response = await ChatService?.createOrganization(formData, {
  //       onUploadProgress: (progressEvent) => {
  //         const percentCompleted = Math.round(
  //           (progressEvent.loaded * 100) / progressEvent.total
  //         );
  //         if (!isVideo) {
  //           setprogress(percentCompleted); // Update upload progress
  //         }
  //       },
  //     });
  //     if (response) {
  //       toastSuccess(
  //         `${
  //           fileArray?.length > 0
  //             ? "File uploaded successfully!"
  //             : "Successfully submitted!"
  //         }`
  //       );
  //       getUserDetails();
  //       setprogress(0);
  //     }
  //     setIsOpen(false);
  //   } catch (error) {
  //     toastError(error?.response?.data?.message);
  //     getUserDetails();
  //   } finally {
  //     formik.resetForm();
  //     setIsCompressing(false);
  //     setLoading(false);
  //     setUploadedFiles([]);
  //     setprogress(0);
  //   }
  // };

  const handleSubmit = async (values) => {
    setLoading(true);
    const fileArray = Array.from(values.file);
    setUploadedFiles(fileArray);
    try {
      const formData = new FormData();
      if (fileArray && fileArray.length > 0) {
        // Loop through each file and upload them one by one
        fileArray.forEach((file) => formData.append("file", file));
      }
      formData.append("category", values.category);
      const response = await ChatService?.createOrganization(formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setprogress(percentCompleted); // Update upload progress
        },
      });
      if (response) {
        toastSuccess(
          `${
            fileArray?.length > 0
              ? "File uploaded successfully!"
              : "Successfully submitted!"
          }`
        );
        getUserDetails();
        setprogress(0);
      }
      setIsOpen(false);
    } catch (error) {
      toastError(error?.response?.data?.message);
      getUserDetails();
    } finally {
      formik.resetForm();
      setLoading(false);
      setUploadedFiles([]);
      setprogress(0);
    }
  };

  // const handleSubmit = async (values) => {
  //   setLoading(true);
  //   const fileArray = Array.from(values.file);
  //   setUploadedFiles(fileArray);

  //   let totalChunks = 0;
  //   let completedChunks = 0;

  //   // Calculate the total number of chunks across all files
  //   fileArray.forEach((file) => {
  //     const chunkSize =
  //       file.size <= MAX_FILE_SIZE ? SMALL_CHUNK_SIZE : LARGE_CHUNK_SIZE;
  //     totalChunks += Math.ceil(file.size / chunkSize);
  //   });

  //   try {
  //     for (const file of fileArray) {
  //       const chunkSize =
  //         file.size <= MAX_FILE_SIZE ? SMALL_CHUNK_SIZE : LARGE_CHUNK_SIZE;
  //       if (file.type.startsWith(VIDEO_TYPE)) {
  //         // await uploadFileInChunks(
  //         //   file,
  //         //   values.category,
  //         //   totalChunks,
  //         //   completedChunks,
  //         //   chunkSize
  //         // );

  //         const chunkFormData = new FormData();
  //         chunkFormData.append("file", file);
  //         chunkFormData.append("category", values.category);

  //         try {
  //           await uploadFile(chunkFormData);
  //         } catch (error) {
  //           console.error(`Error uploading file:`, error);
  //           break;
  //         }
  //       } else {
  //         const smallFormData = new FormData();
  //         smallFormData.append("file", file);
  //         smallFormData.append("category", values.category);
  //         await uploadFile(smallFormData, completedChunks, totalChunks);
  //         completedChunks++;
  //       }
  //     }

  //     toastSuccess("Files uploaded successfully!");
  //     getUserDetails();
  //     setIsOpen(false);
  //   } catch (error) {
  //     toastError(error?.response?.data?.message);
  //   } finally {
  //     formik.resetForm();
  //     setIsCompressing(false);
  //     setLoading(false);
  //     setUploadedFiles([]);
  //     setprogress(0);
  //   }
  // };

  // Function to upload files in chunks (1MB for <= 5MB, 5MB otherwise)
  const uploadFileInChunks = async (
    file,
    category,
    totalChunks,
    completedChunks,
    chunkSize
  ) => {
    const chunkCount = Math.ceil(file.size / chunkSize);

    for (let i = 0; i < chunkCount; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, file.size);
      const chunkBlob = file.slice(start, end);

      const chunkFile = new File([chunkBlob], file.name, {
        type: file.type,
        lastModified: file.lastModified,
      });

      const chunkFormData = new FormData();
      chunkFormData.append("file", chunkFile);
      chunkFormData.append("category", category);

      try {
        await uploadFile(chunkFormData, completedChunks + i, totalChunks);
      } catch (error) {
        console.error(`Error uploading chunk ${i + 1}:`, error);
        break;
      }
    }
    completedChunks += chunkCount; // Update completed chunks after each file is fully uploaded
  };

  // Upload helper function with cumulative progress tracking
  const uploadFile = async (formData, completedChunks, totalChunks) => {
    try {
      await ChatService?.createOrganization(formData, {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
          setprogress(percentCompleted); // Update single progress bar for all chunks
        },
      });
    } catch (error) {
      throw error; // Rethrow to handle in the main function
    }
  };

  const formik = useFormik({
    initialValues: {
      category: "", // Company Name
      file: null, // File
    },
    validationSchema: Yup.object({
      category: Yup.string()
        .required("Company name is required")
        .min(3, "Company name must be at least 3 characters long")
        .max(63, "Company name must be at most 63 characters long")
        .matches(
          /^[a-zA-Z0-9](?!.*[.]{2})[a-zA-Z0-9._-]*[a-zA-Z0-9]$/,
          "Company name must start and end with an alphanumeric character, and contain only alphanumeric characters, underscores, or hyphens."
        ),

      file: Yup.mixed().required("File is required"),
    }),
    onSubmit: handleSubmit,
  });

  // Function to dynamically render the correct file icon
  const renderFileIcon = (fileType) => {
    switch (fileType) {
      case "pdf":
        return <FaFilePdf className="text-[#CC0000] text-2xl" />;
      case "doc":
      case "docx":
        return <IoDocumentText className="text-[#3980FB] text-2xl" />;
      case "xlsx":
      case "xls":
        return <FaFileExcel className="text-[#00733B] text-2xl" />;
      case "jpg":
      case "jpeg":
        return <BiSolidFileJpg className="text-[#2C7FC3] text-2xl" />;
      case "png":
        return <BiSolidFilePng className="text-[#F05C58] text-2xl" />;
      case "mp4":
      case "mov":
      case "wmv":
      case "avi":
      case "flv":
      case "mkv":
        return <FaVideo className="text-primary text-2xl" />; // Video icon
      default:
        return <IoDocumentText className="text-[#9E9E9E] text-2xl" />;
    }
  };

  const handleDeleteFile = async (id) => {
    setFileDeleteLoading(id);
    try {
      const response = await ChatService?.deleteFile(companyId, id);
      if (response) {
        setFileDeleteLoading("");
        getUserDetails();
        toastSuccess("File deleted successfully");
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    } finally {
      setFileDeleteLoading("");
    }
  };

  useEffect(() => {
    const companyName = user?.organization?.name;
    const companyID = user?.organization?._id;
    const documents = user?.organization?.document; // This is an array of URLs

    // Set the first document URL, if it exists
    const fileUrl =
      Array.isArray(documents) && documents.length > 0 ? documents[0] : null;

    // Extract the file extension if fileUrl exists
    const extension = fileUrl ? fileUrl.url.split(".").pop() : null;

    // Update state
    setFile(fileUrl);
    setCompany(companyName);
    formik.setFieldValue("category", companyName);
    setCompanyId(companyID);
    setFileType(extension);

    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
  }, [user]);

  const getUserDetails = async () => {
    try {
      const response = await UserService?.getUserDetails();
      if (response) {
        dispatch(setUser(response?.data?.data));
      }
    } catch (error) {
      toastError(error?.response?.data?.message);
    }
  };

  /* const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    formik.setFieldValue("file", files);
    if (files.length > 0) {
      const extensions = files.map((file) => file.name.split(".").pop());
    setFileType(extensions);
      setSelectedFile(files);
      }

    setTimeout(() => {
      formik.submitForm();
      }, 1000);
  }; */

  // const handleFileChange = async (e) => {
  //   const files = Array.from(e.target.files);

  //   let compressedFiles = [];
  //   for (const file of files) {
  //     const fileType = file.type;

  //     if (fileType.startsWith("video/")) {
  //       try {
  //         setprogress(10);
  //         setUploadedFiles(files);
  //         setIsCompressing(true);
  //         setprogress(15);
  //         const compressedVideo = await compressVideo(file, 0.3);

  //         compressedFiles.push(compressedVideo);
  //         setprogress(100);
  //       } catch (error) {
  //         console.error("Error compressing video:", error);
  //         compressedFiles.push(file);
  //       } finally {
  //       }
  //     } else {
  //       setIsCompressing(true);
  //       compressedFiles.push(file);
  //     }
  //   }

  //   formik.setFieldValue("file", compressedFiles);

  //   setTimeout(() => {
  //     formik.submitForm();
  //   }, 300);
  // };

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    formik.setFieldValue("file", files);
    if (files.length > 0) {
      const extensions = files.map((file) => file.name.split(".").pop());
      setFileType(extensions);
      setSelectedFile(files);
    }

    setTimeout(() => {
      formik.submitForm();
    }, 300);
  };

  /* const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    formik.setFieldValue("file", files);
    if (files.length > 0) {
      const extensions = files.map((file) => file.name.split(".").pop());
      setFileType(extensions);
      setSelectedFile(files);
    }
    setTimeout(() => {
      formik.submitForm();
    }, 300);
  }; */

  // const handleFileChange = (e) => {
  //   const files = Array.from(e.target.files);
  //   const maxSize = 25 * 1024 * 1024; // 5MB in bytes
  //   const largeFiles = files.filter((file) => file.size > maxSize);

  //   // if (largeFiles.length > 0) {
  //   //   // Set the error message in local state if any file exceeds the size limit
  //   //   setFileSizeError("File must be 25MB or less.");
  //   //   formik.setFieldValue("file", []); // Reset file in Formik to avoid submission with error
  //   //   return;
  //   // }

  //   // Clear error message if all files are within size limit
  //   setFileSizeError("");
  //   formik.setFieldValue("file", files);

  //   if (files.length > 0) {
  //     const extensions = files.map((file) => file.name.split(".").pop());
  //     setFileType(extensions);
  //     setSelectedFile(files);
  //   }

  //   setTimeout(() => {
  //     formik.submitForm();
  //   }, 300);
  // };

  // Video compression function remains the same
  const compressVideo = async (file, scaleFactor) => {
    // return new Promise((resolve, reject) => {
    //   const video = document.createElement("video");
    //   video.src = URL.createObjectURL(file);
    //   video.muted = true;

    //   // Determine the mimeType and extension based on the file type
    //   const supportedTypes = {
    //     "video/mp4": { mimeType: "video/mp4; codecs=vp9", extension: "mp4" },
    //     "video/quicktime": { mimeType: "video/quicktime", extension: "mov" },
    //     "video/x-ms-wmv": { mimeType: "video/x-ms-wmv", extension: "wmv" },
    //     "video/x-msvideo": { mimeType: "video/x-msvideo", extension: "avi" },
    //     "video/x-flv": { mimeType: "video/x-flv", extension: "flv" },
    //     "video/x-matroska": { mimeType: "video/x-matroska", extension: "mkv" },
    //   };

    //   // Check if the file type is supported; default to 'mp4' if not
    //   const fileType = supportedTypes[file.type] ? file.type : "video/mp4";
    //   const { mimeType, extension } =
    //     supportedTypes[fileType] || supportedTypes["video/mp4"];
    //   video.onloadeddata = async () => {
    //     if (!video.videoWidth || !video.videoHeight) {
    //       return reject("Video dimensions are not available.");
    //     }

    //     const canvas = document.createElement("canvas");
    //     const ctx = canvas.getContext("2d");

    //     // Set canvas size to scale down the resolution
    //     canvas.width = Math.floor(video.videoWidth * scaleFactor);
    //     canvas.height = Math.floor(video.videoHeight * scaleFactor);

    //     const recordedChunks = [];
    //     const mediaRecorder = new MediaRecorder(canvas.captureStream(10), {
    //       mimeType: mimeType,
    //       videoBitsPerSecond: 300000, // Set a lower bitrate (e.g., 500 kbps)
    //     });
    //     mediaRecorder.ondataavailable = (event) => {
    //       if (event.data.size > 0) {
    //         recordedChunks.push(event.data);
    //       }
    //     };

    //     mediaRecorder.onstop = () => {
    //       const blob = new Blob(recordedChunks, { type: fileType });
    //       const originalName = file.name.split(".").slice(0, -1).join(".");
    //       const compressedFile = new File(
    //         [blob],
    //         `${originalName}.${extension}`,
    //         {
    //           type: fileType,
    //         }
    //       );

    //       if (compressedFile.size > file.size * 0.2) {
    //         reject("Compressed file is not below the 80% reduction goal.");
    //       } else {
    //         resolve(compressedFile);
    //       }
    //     };

    //     setprogress(35);
    //     setTimeout(() => {
    //       setprogress(45);
    //     }, 200);
    //     setTimeout(() => {
    //       setprogress(60);
    //     }, 1000);
    //     setTimeout(() => {
    //       setprogress(80);
    //     }, 2500);
    //     video.play();
    //     mediaRecorder.start();

    //     video.ontimeupdate = () => {
    //       ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    //     };

    //     video.onended = () => {
    //       mediaRecorder.stop();
    //     };

    //     setTimeout(() => {
    //       setprogress(90);
    //     }, 3000);

    //     video.onerror = () => reject("Error processing video.");
    //   };

    //   video.onerror = () => reject("Error loading video.");
    // });

    const video = document.createElement("video");
    video.src = URL.createObjectURL(file);

    await video.play(); // Ensure the video loads

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Set the desired compression resolution (reduce original width and height)
    const newWidth = video.videoWidth * 0.2; // Example: reduce width by 50%
    const newHeight = video.videoHeight * 0.2;
    canvas.width = newWidth;
    canvas.height = newHeight;

    // Draw each frame onto the canvas and capture it as a Blob
    ctx.drawImage(video, 0, 0, newWidth, newHeight);
    return canvas.toBlob(
      (blob) => {
        const compressedUrl = URL.createObjectURL(blob);
        // setCompressedVideo(compressedUrl);

        const blobUrl = compressedUrl;

        // Create download link
        const link = document.createElement("a");
        link.href = blobUrl;
        link.download = "downloaded-image";

        // Trigger download
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up object URL
        URL.revokeObjectURL(blobUrl);

        // return compressedUrl;
      },
      "video/mp4",
      0.4 // Compression quality (0-1); adjust as needed
    );
  };

  useEffect(() => {
    if (user) {
      getUserDetails();
    }
  }, []);

  return (
    <div className="w-full min-h-screen">
      <Navbar title="Organization" />
      {/* <VideoCompressor /> */}

      {isLoading ? (
        <div className="flex justify-center items-center h-[calc(100vh-180px)]">
          <img src={Loader} alt="Loader" className="w-20" />
        </div>
      ) : (
        <div className="p-8 flex items-center justify-between flex-col h-full w-full gap-5 min-h-[calc(100vh-97px)]">
          <form onSubmit={formik.handleSubmit} className="w-full">
            <div className="flex justify-between items-center gap-3 w-full">
              <div className="flex flex-col gap-4 w-full">
                <div className="font-semibold text-xl text-white">
                  Organization
                </div>

                <div className="flex gap-2 max-w-[400px] w-full">
                  <Label
                    htmlFor="category"
                    className="text-white whitespace-nowrap text-lg mt-1"
                  >
                    Company Name :
                  </Label>
                  <div className="w-full sm:min-w-64">
                    <Input
                      id="category"
                      placeholder="Enter Your Company Name"
                      value={formik.values.category}
                      {...formik.getFieldProps("category")}
                      className="w-full"
                      readonly={company ? true : false}
                    />
                  </div>
                  {!company && (
                    <button
                      type="submit"
                      className="bg-primary hover:bg-btnHover text-white text-base px-3 py-2 rounded-md"
                    >
                      Save
                    </button>
                  )}
                </div>
                {formik.touched.category && formik.errors.category ? (
                  <div className="text-red-500 text-sm flex px-36">
                    {formik.errors.category}
                  </div>
                ) : null}
              </div>
            </div>

            <div className="grid gap-10">
              <div className="flex justify-center mt-10 text-xl">
                {isCompressing ? (
                  <div className="h-[195px] items-center border-dashed border-2 rounded-lg !border-primary/50 w-full p-5 lg:p-10 m-auto cursor-pointer grid gap-2 justify-center">
                    <img src={Loader} alt="Loader" className="w-20" />
                  </div>
                ) : (
                  <div className="w-full">
                    <label
                      htmlFor="uploads"
                      className="border-dashed border-2 rounded-lg !border-primary/50 w-full p-5 lg:p-10 m-auto cursor-pointer grid gap-2 justify-center"
                    >
                      <div className="flex justify-center mb-2">
                        <img
                          src={Upload}
                          alt="Upload File"
                          className="max-sm:h-14"
                        />
                      </div>
                      <h6 className="text-white/60 text-lg sm:text-xl text-center">
                        Click to upload your file
                      </h6>
                      {/* <p className="text-sm text-white/50 text-center">
                        Maximum file size 5 mb.
                      </p> */}
                      <input
                        type="file"
                        id="uploads"
                        name="file"
                        hidden
                        onChange={handleFileChange}
                        accept=".txt,.pdf,.docx,.rtf,.doc,.xls,.xlsx,.mp4,.mov,.wmv,.avi,.flv,.mkv"
                        multiple
                      />
                    </label>
                    {(formik.errors.file && formik.touched.file) ||
                    fileSizeError ? (
                      <div className="text-red-500 text-sm mt-2">
                        {fileSizeError || formik.errors.file}
                      </div>
                    ) : null}
                  </div>
                )}
              </div>
              {uploadedFiles &&
                uploadedFiles?.length > 0 &&
                uploadedFiles?.map((res) => {
                  const fileExtension = res?.name
                    ?.split(".")
                    .pop()
                    .toLowerCase();
                  return (
                    <div className="grid grid-cols-1 sm:grid-cols-[repeat(auto-fit,_minmax(500px,_1fr))] gap-5">
                      <div
                        className={`p-4 bg-sidebar rounded-lg grid gap-4 border ${
                          fileExtension === "pdf"
                            ? "border-[#CC0000]"
                            : fileExtension === "doc" ||
                              fileExtension === "docx"
                            ? "border-[#3980FB]"
                            : fileExtension === "xlsx" ||
                              fileExtension === "xls"
                            ? "border-[#00733B]"
                            : fileExtension === "jpg" ||
                              fileExtension === "jpeg"
                            ? "border-[#2C7FC3]"
                            : fileExtension === "mp4" ||
                              fileExtension === "avi" ||
                              fileExtension === "mkv" ||
                              fileExtension === "mov" ||
                              fileExtension === "wmv" ||
                              fileExtension === "flv"
                            ? "border-primary/50"
                            : "border-primary/50"
                        }`}
                      >
                        <div className="flex items-center gap-4">
                          <div>{renderFileIcon(fileExtension)}</div>
                          <div className="flex flex-col justify-between w-full gap-3">
                            <div className="flex items-start justify-between gap-3 w-full h-fit">
                              <h6 className="text-white/80 text-xl leading-none">
                                {res?.name}
                              </h6>
                              <h6 className="text-sm text-white/70 leading-none">
                                {progress === 100
                                  ? "Uploading. . ."
                                  : `${progress}%`}
                              </h6>
                            </div>
                          </div>
                        </div>
                        <div className="w-full">
                          <Progress value={progress} className="w-[50%]" />
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>
            {user?.organization?.document &&
            user.organization.document.length > 0 ? (
              <div className="w-full mt-14">
                <div className="mb-2">Files:</div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {user.organization.document.map((fileUrl, index) => {
                    const extension = fileUrl.url.split(".").pop();
                    const fileType = extension.toLowerCase();

                    // Check if the file is a video
                    const isVideo = [
                      "mp4",
                      "avi",
                      "mkv",
                      "mov",
                      "wmv",
                      "flv",
                    ].includes(fileType);

                    // If it's a video, skip rendering it
                    // if (isVideo) return null;

                    return (
                      <div
                        key={index}
                        className={`relative flex items-center justify-center gap-2 p-4 border rounded-md uppercase ${
                          fileType === "pdf"
                            ? "border-[#CC0000]"
                            : fileType === "doc" || fileType === "docx"
                            ? "border-[#3980FB]"
                            : fileType === "xlsx" || fileType === "xls"
                            ? "border-[#00733B]"
                            : fileType === "jpg" || fileType === "jpeg"
                            ? "border-[#2C7FC3]"
                            : "border-primary/50"
                        }`}
                      >
                        <div
                          className="flex gap-2 cursor-pointer break-all"
                          onClick={() => {
                            if (fileType === "xlsx" || fileType === "xls") {
                              // For excel files, trigger download
                              const link = document.createElement("a");
                              link.href = fileUrl.url;
                              link.download = fileUrl.url.substring(
                                fileUrl.url.lastIndexOf("/") + 1
                              );
                              link.click();
                            } else {
                              // For all other files, open in a new tab
                              window.open(fileUrl.url, "_blank");
                            }
                          }}
                        >
                          <div className="cursor-pointer">
                            {renderFileIcon(fileType)}
                          </div>
                          <div className="line-clamp-1">{fileUrl.name}</div>
                        </div>
                        <div
                          className={`absolute -right-3 -top-3 border-white/20 border rounded-full cursor-pointer ${
                            fileDeleteLoading
                              ? "hover:none"
                              : "hover:bg-[#CC0000] hover:border-[#CC0000]"
                          } duration-200 p-1 bg-[#070710]`}
                          onClick={() => handleDeleteFile(fileUrl.url)}
                        >
                          {fileDeleteLoading === fileUrl.url ? (
                            <div className="w-5 h-5">
                              <img src={Loader} alt="Loader" />
                            </div>
                          ) : (
                            <X className="h-4 w-4" />
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div className="grid gap-4 justify-center items-center font-bold">
                <img src={NoFiles} alt="" />
              </div>
            )}
          </form>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Organization;
